module.exports = __webpack_public_path__ + "img/prioritas_bosspack_dg.6bc35aba.png";